import { Button, Container, Text } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

const NotFound = () => {
  return (
    <Container
      h="100vh"
      alignItems="stretch"
      justifyContent="center"
      textAlign="center"
      maxW="sm"
      centerContent
    >
      <Text
        fontSize="8xl"
        color="main"
        fontWeight="bold"
        lineHeight="1"
        mb={4}
      >
        404
      </Text>
      <Text fontSize="md">Oops!</Text>
      <Text fontSize="md">Page not found.</Text>
      <Button
        asChild
        color="main"
        borderColor="main"
        variant="outline"
        mt={4}
      >
        <Link to="/">
          Go back
        </Link>
      </Button>
    </Container>
  )
}

export default NotFound
